import React from 'react'
import { Portal } from 'react-portal'
import Transition from 'react-transition-group/Transition'
import styled from 'styled-components'

import Fade from '../transitions/Fade'

const ModalContainer = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  z-index: 1500;
  position: fixed;
`

const Overlay = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.54);
`

interface ModalProps {
  onClose?: () => void
  show: boolean
  children: React.ReactNode
}

const Modal: React.FC<ModalProps> = ({ children, onClose, show }) => {
  return (
    <Transition in={show} timeout={300}>
      {(state) =>
        ['entering', 'entered', 'exiting'].includes(state) && (
          <Portal>
            <ModalContainer>
              <Fade in={show}>
                <Overlay onClick={onClose} />
              </Fade>
              {children}
            </ModalContainer>
          </Portal>
        )
      }
    </Transition>
  )
}

export default Modal
